"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _EmotionCacheProvider = require("./EmotionCacheProvider");
Object.keys(_EmotionCacheProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EmotionCacheProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EmotionCacheProvider[key];
    }
  });
});
//# sourceMappingURL=index.js.map